import { RegisterData } from '../types/RegisterType';

/**
 * Salva pré-cadastro na API
 * Não bloqueia o fluxo se houver erro
 */
export const savePreRegistration = async (
  step: number,
  data: Partial<RegisterData>,
): Promise<void> => {
  try {
    // Identificar pré-cadastro por email ou phone
    const identifier = data.signup?.email || data.carwash?.phone;

    if (!identifier) {
      // Ainda não tem dados suficientes para salvar
      return;
    }

    const payload = {
      email: data.signup?.email,
      phone: data.carwash?.phone,
      full_name: data.owner?.full_name,
      document: data.owner?.document,
      car_wash_name: data.carwash?.car_wash_name,
      company_name: data.carwash?.company_name,
      cnpj: data.carwash?.cnpj,
      zip_code: data.address?.zip_code,
      state: data.address?.state,
      city: data.address?.city,
      neighborhood: data.address?.neighborhood,
      street: data.address?.street,
      number: data.address?.number,
      complement: data.address?.complement,
      current_step: step,
      category_id: data.carwash?.category_id,
      survey_data: data.survey || null,
      // Status não é enviado - API controla
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}pre-registration`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      // Não lançar erro, apenas logar
      console.warn('Erro ao salvar pré-cadastro:', response.statusText);
    }
  } catch (error) {
    // Não bloquear o fluxo se houver erro
    console.warn('Erro ao salvar pré-cadastro:', error);
  }
};
